import { Challenge, ChallengeType } from '@frontend/data-access';

import ChallengeDashboardApplicationEvaluations from '../challenge-dashboard-application-evaluations/challenge-dashboard-application-evaluations';
import ChallengeDashboardApplications from '../challenge-dashboard-applications/challenge-dashboard-applications';
import ChallengeDashboardBusinessArea from '../challenge-dashboard-business-area/challenge-dashboard-business-area';
import ChallengeDashboardEvaluatingApplications from '../challenge-dashboard-evaluating-applications/challenge-dashboard-evaluating-applications';
import ChallengeDashboardIntraStats from '../challenge-dashboard-intra-stats/challenge-dashboard-intra-stats';
import ChallengeDashboardOpenStats from '../challenge-dashboard-open-stats/challenge-dashboard-open-stats';
import ChallengeDashboardRegions from '../challenge-dashboard-regions/challenge-dashboard-regions';

export interface ChallengeDashboardProps {
  challenge: Challenge & { __typename?: string };
  challengeType: ChallengeType;
}

export function ChallengeDashboard({
  challenge,
  challengeType,
}: ChallengeDashboardProps) {
  if (challengeType === 'entrepreneurship') {
    return (
      <div className="space-y-6">
        <ChallengeDashboardOpenStats challenge={challenge} />
        <ChallengeDashboardApplications challenge={challenge} />
        <ChallengeDashboardApplicationEvaluations challenge={challenge} />
        <ChallengeDashboardEvaluatingApplications challenge={challenge} />
      </div>
    );
  }
  return (
    <div className="space-y-6">
      <ChallengeDashboardIntraStats challenge={challenge} />
      {/* <ChallengeDashboardIdeas challenge={challenge} /> */}
      {/* <ChallengeDashboardDecision challenge={challenge} /> */}
      <ChallengeDashboardBusinessArea challenge={challenge} />
      <ChallengeDashboardRegions challenge={challenge} />
    </div>
  );
}

export default ChallengeDashboard;
